var _defs, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew303({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 8 14.93 12 14.93 4 8 8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 8 1.07 4 1.07 12 8 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew303);
export default __webpack_public_path__ + "static/media/Symbolpack_New_303.05e96e4d5e5823b2e3dd4b2ed2bd1857.svg";
export { ForwardRef as ReactComponent };